import { getLabel } from "../../../../../../../hooks/use-labels";
import { getStyle } from "../../../../../../../hooks/use-styles";

import TypeDescriptionView from "./TypeDescriptionView";
import { getUnsupportedProducts, prepareViewDetails } from "./type-content-utils";

const DeliveryTypeContent = ({ deliveryType, unsupportedProducts }) => {
  const { code, defaultTitle } = deliveryType;

  getUnsupportedProducts(unsupportedProducts);
  return (
    <div className="delivery-type-list-content">
      <div className="type-list-title font-16-bold-500-lh-22">
        {getLabel(code) || defaultTitle}
      </div>

      <div
        className="type-description font-14-normal-400-lh-18"
        style={{ color: getStyle("secondaryLightGray") }}
      >
        <TypeDescriptionView
          {...prepareViewDetails(deliveryType)}
          unsupportedProducts={unsupportedProducts}
        />
      </div>
    </div>
  );
};

export default DeliveryTypeContent;
